import React from 'react';

let ControlBar = function ControlBar(props) {
 
  /*let style = {
    width: '200px',
    margin: '10px 5px 0px 5px'
  };*/

  return (
    <div className="control-bar">{props.title}</div>
  );
};

export default ControlBar;



// WEBPACK FOOTER //
// ./src/ControlBar.jsx